<template>
    <div class="choose__data__body">
        <slot></slot>
        <Footer />
    </div>
</template>

<script setup>
import Footer from '../components/SecondaryFooter.vue'
</script>
